var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4434 7.01807C21.1002 7.01807 22.4434 8.36121 22.4434 10.0181V19.1372C22.4431 20.7938 21.1001 22.1372 19.4434 22.1372H10.3252C8.66834 22.1372 7.3252 20.7931 7.3252 19.1362V16.1597C7.95211 16.3486 8.61618 16.4526 9.30469 16.4526C13.089 16.4526 16.1572 13.3844 16.1572 9.6001C16.1572 8.68636 15.976 7.81515 15.6514 7.01807H19.4434Z",
    fill: "#FBAF5D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.22046,
    cy: 8.5271,
    r: 6.66382,
    fill: "#FBAF5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.fd5f63685cde8fca87c65dace68aa135.svg";
export { ForwardRef as ReactComponent };